import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute } from '@angular/router';
import { ActionsService } from '../services/actions.service';
import { DateService } from '../services/date.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';

@Component({
  selector: 'app-avt-note-frais',
  templateUrl: './avt-note-frais.component.html',
  styleUrls: ['./avt-note-frais.component.scss'],
})
export class AvtNoteFraisComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public actionsService: ActionsService,
    public dateService: DateService
  ) {}
  @ViewChild('listeFraisComponen', { static: false })
  listeFraisComponen: AvtListesComponent;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd/MM/yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        valueTotal: 'Total',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_NbH',
        Lg_Code: '',
        TableRD_Des: 'Nbr H',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_Km',
        Lg_Code: '',
        TableRD_Des: 'KM',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_NbrChevaux',
        Lg_Code: '',
        TableRD_Des: 'Nbr.Ch',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_NRM',
        Lg_Code: '',
        TableRD_Des: 'Nbr.repas.midi',
        TableRD_Largeur: 110,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_NRS',
        Lg_Code: '',
        TableRD_Des: 'Nbr.repas.soir',
        TableRD_Largeur: 110,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_NNH',
        Lg_Code: '',
        TableRD_Des: 'Nbr.nuit.hotel',
        TableRD_Largeur: 110,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_Autre',
        Lg_Code: '',
        TableRD_Des: 'Autre frais',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_Peage',
        Lg_Code: '',
        TableRD_Des: 'Péages',
        TableRD_Largeur: 60,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_TauxKm',
        Lg_Code: '',
        TableRD_Des: 'Taux Km',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtFrais_Total',
        Lg_Code: '',
        TableRD_Des: 'Total',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  exist: boolean = false;
  // liste des moi : janvier, fevrier,... dessembre
  moisTab = this.dateService.monthsTab;

  // le mois selectionner
  mois;

  // année selectionner
  annee;

  // tableau liste de 5 derinier année
  anneeTab;

  // 0 frais collaborateur connecter
  // 1 tous les frais de tous les collaborateur
  fenetre;

  // liste des colaborateur
  listeCollaborateurs = [];

  // selected collaborateur
  collaborateur;

  // new ds note de frais
  dsFrais;

  //liste note frais à ajouter dans la base de donnée
  dsFraisToAdd;
  rowFrai;
  listeTauxKm;
  genNewRowFrai() {
    return JSON.parse(JSON.stringify(this.rowFrai));
  }
  ngOnInit() {
    this.collaborateur = {};
    this.getTaux();
    this.readParamUrl();
  }
  getTaux() {
    this.generalService
      .rechercheTable(this.generalService.url + 'avtTauxKm')
      .subscribe((data) => {
        this.listeTauxKm = data;
      });
  }

  exportToExcel() {
    this.generalService.exportToExcel(
      this.listeFraisComponen,
      'MA NOTE DE FRAIS'
    );
  }
  // ds vide note de frais
  getInitDsFrais() {
    this.generalService
      .rechercheTable('ds/formdata?code=avtFrais')
      .subscribe((data) => {
        this.dsFrais = data;
        this.rowFrai = JSON.parse(JSON.stringify(data.avtFrais[0]));
        this.dsFraisToAdd = JSON.parse(JSON.stringify(data));
        this.dsFraisToAdd.avtFrais = [];
        this.setCollaborateur();
      });
  }
  init() {
    this.setListeAnnee();
    this.mois = new Date().getMonth();
    this.annee = this.anneeTab[5];
    this.getInitDsFrais();
  }
  //creation de liste de 5 derinier année
  setListeAnnee() {
    var date = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    var annee = date.getFullYear();
    this.anneeTab = [
      annee - 5,
      annee - 4,
      annee - 3,
      annee - 2,
      annee - 1,
      annee,
      annee + 1,
    ];
  }
  filterColaborateur(data) {}
  setCollaborateur() {
    if (
      this.generalService.isNotEmpty(this.generalService.collaborateurConnecter)
    )
      this.generalService
        .rechercheTable(this.generalService.url + 'avtperso&param=0')
        .subscribe((data) => {
          data = this.generalService.sort(data, 'Perso_Nom');
          // 1 tous les frais de tous les collaborateur
          if (this.fenetre == '1' || this.fenetre == 'fraiscollaborateur') {
            this.listeCollaborateurs = data;
            if (this.fenetre == 'fraiscollaborateur')
              this.setColonneListeFraisComponenToReadOnlyOrNot(true);
          }
          // 0 frais collaborateur connecter
          if (this.fenetre == '0') {
            this.listeCollaborateurs = [
              data.find((col) => {
                return (
                  col.Perso_Matricule ==
                  this.generalService.collaborateurConnecter
                );
              }),
            ];
          }
          if (this.listeCollaborateurs.length > 0) {
            this.collaborateur = this.listeCollaborateurs[0];
          }
          this.exist = true;
        });
    else
      setTimeout(() => {
        this.setCollaborateur();
      }, 100);
  }
  //affichage des frais selon l'anner et mois et collaborateur selectionner
  afficherFrais() {
    if (this.collaborateur && this.rowFrai && this.listeTauxKm) {
      this.exist = false;
      var date_Debut = this.dateService.setFormatDateRechercheServer(
        new Date(this.annee, this.mois, 1)
      );
      var lastDayOfMonth = this.dateService.getLastDayOfMonth(this.mois + 1);
      var date_Fin = this.dateService.setFormatDateRechercheServer(
        new Date(this.annee, this.mois, lastDayOfMonth)
      );
      // if(this.mois < (new Date()).getMonth())
      //   this.setColonneListeFraisComponenToReadOnlyOrNot(true)
      // else
      // this.setColonneListeFraisComponenToReadOnlyOrNot(false)

      this.generalService
        .rechercheTable(
          this.generalService.url +
            'avtFraisColaboDDF&param=' +
            this.collaborateur.Perso_Matricule +
            ',' +
            date_Debut +
            ',' +
            date_Fin
        )
        .subscribe((data) => {
          var url =
            this.generalService.url +
            'avtactionDColF&param=' +
            this.collaborateur.Perso_Matricule +
            ',' +
            date_Debut +
            ',' +
            date_Fin;
          this.generalService.rechercheTable(url).subscribe((data2) => {
            this.genererListeNoteFrais(data, data2);
          });
        });
    }
  }
  //
  genererListeNoteFrais(listeFrais, listeActionActionDColl) {
    var listeFraisMonth = [];
    var date = new Date(this.annee, this.mois, 1);
    var lastDayOfMonth = this.dateService.getLastDayOfMonth(this.mois + 1);
    var dateNow = new Date();
    dateNow.setDate(dateNow.getDate() - 1);
    for (var i = 1; i < lastDayOfMonth + 1; i++) {
      date.setDate(i);
      if (date.getTime() <= dateNow.getTime()) {
        var myDate = this.dateService.setToFormatDateServerStr(date);
        var findFrais = listeFrais.filter((element) => {
          return (
            this.dateService.setToFormatDateServerStr(element.avtFrais_Date) ==
            myDate
          );
        });
        if (findFrais.length > 0) {
          // var frais = JSON.parse( JSON.stringify(this.dsFrais.avtFrais[0]) )
          // frais.avtFrais_Date = this.dateService.setToFormatDateServerStr(date)
          // listeFrais.push(frais)

          listeFraisMonth.push(findFrais[0]);
        } else {
          var newRowFrai = this.genNewRowFrai();
          var listeActionD = listeActionActionDColl.filter((actionD) => {
            return (
              this.dateService.setToFormatDateServerStr(
                actionD.avtActionD_date
              ) == myDate
            );
          });
          newRowFrai.avtFrais_NbH =
            this.actionsService.getNbrHeure(listeActionD);
          newRowFrai.avtFrais_Date =
            this.dateService.setToFormatDateServerStr(date);
          newRowFrai.Perso_Matricule = this.collaborateur.Perso_Matricule;
          newRowFrai.avtFrais_NbrChevaux =
            this.collaborateur.Perso_VoitureNBChaveaux;
          var findTaux = this.listeTauxKm.find((taux) => {
            return taux.avtTaux_NbrCh == newRowFrai.avtFrais_NbrChevaux;
          });

          newRowFrai.avtFrais_TauxKm = findTaux ? findTaux.avtTaux_Sup20 : null;
          listeFraisMonth.push(newRowFrai);
        }
      }
    }
    this.listeFraisComponen.setDataSource(
      this.sortFraisColaborateur(listeFraisMonth)
    );
    this.exist = true;
  }
  // trier la liste des frais collaborateur selon la date
  sortFraisColaborateur(listeFrais) {
    listeFrais.sort(function (element1, element2) {
      var element11 = new Date(element1.avtFrais_Date).getTime();
      var element22 = new Date(element2.avtFrais_Date).getTime();
      return element11 - element22;
    });
    return listeFrais;
  }
  //set Colonne ListeFraisComponen To ReadOnly Or Not
  setColonneListeFraisComponenToReadOnlyOrNot(readOnly: boolean) {
    for (var i = 0; i < this.columns.TableRD.length - 1; i++) {
      this.columns.TableRD[i].TableRD_ReadOnly = readOnly;
    }
    //pour modifier le type colonne de type composon de recherche (3) ou affichage simple (0)
    // if(readOnly)
    //   this.columns.TableRD[1].TableRD_Type = 0
    // else
    //   this.columns.TableRD[1].TableRD_Type = 3
  }
  compte = 0;
  enregistrer() {
    this.compte = 0;
    for (let i = 0; i < this.listeFraisComponen.dataSource.data.length; i++) {
      this.exist = false;
      var frais = this.listeFraisComponen.dataSource.data[i];
      if (this.generalService.isNotEmpty(frais.avtFrais_Id)) {
        this.compte++;
        this.modifierFrais(frais);
      } else {
        if (
          this.generalService.isNotEmpty(frais.Tiers_code) ||
          this.generalService.isNotEmpty(frais.avtAction_Code) ||
          this.generalService.isNotEmpty(frais.avtFrais_Km) ||
          this.generalService.isNotEmpty(frais.avtFrais_NRM) ||
          this.generalService.isNotEmpty(frais.avtFrais_NRS) ||
          this.generalService.isNotEmpty(frais.avtFrais_NNH) ||
          this.generalService.isNotEmpty(frais.avtFrais_Autre) ||
          this.generalService.isNotEmpty(frais.avtFrais_Peage)
        ) {
          this.dsFraisToAdd.avtFrais.push(frais);
        }
      }
    }
    this.ajouterFrais();
  }
  // creation dans la base de donnée un nouveau frais
  ajouterFrais() {
    if (this.dsFraisToAdd.avtFrais.length > 0) {
      this.compte++;
      this.generalService.enregisterTable(this.dsFraisToAdd).subscribe(
        (data) => {
          this.generalService.dialogSuccess('Frais ajouter', true);
          this.dsFraisToAdd.avtFrais = [];
          this.compte--;
          if (this.compte == 0) {
            this.exist = true;
            this.afficherFrais();
          }
        },
        () => {
          this.compte--;
          if (this.compte == 0) {
            this.exist = true;
          }
          this.generalService.dialogSuccess('Frais non ajouter', false);
        }
      );
    }
  }
  // modification dans la base de donnée un encien frais
  modifierFrais(frais) {
    this.generalService
      .rechercheTable('ds/formdata?code=avtFrais&val=' + frais.avtFrais_Id)
      .subscribe(
        (data) => {
          frais.U_timestamp = data.avtFrais[0].U_timestamp;
          data.avtFrais = [frais];
          this.generalService.enregisterTable(data).subscribe(
            () => {
              this.generalService.dialogSuccess(
                'le frais de la date' + frais.avtFrais_Date + ' est enregisté',
                true
              );
              this.compte--;
              if (this.compte == 0) {
                this.exist = true;
                this.afficherFrais();
              }
            },
            () => {
              this.compte--;
              if (this.compte == 0) {
                this.exist = true;
                this.afficherFrais();
              }
              this.generalService.dialogSuccess(
                'le frais de la date' +
                  frais.avtFrais_Date +
                  ' est non enregisté',
                false
              );
            }
          );
        },
        () => {
          this.compte--;
          if (this.compte == 0) {
            this.exist = true;
            this.afficherFrais();
          }
          this.generalService.dialogSuccess(
            'le frais de la date' + frais.avtFrais_Date + ' est non enregisté',
            false
          );
        }
      );
  }
  outputAction(event) {
    if (
      this.listeTauxKm &&
      this.generalService.isNotEmpty(event.row.avtFrais_NbrChevaux)
    ) {
      var findTaux = this.listeTauxKm.find((taux) => {
        return taux.avtTaux_NbrCh == parseInt(event.row.avtFrais_NbrChevaux);
      });
      if (findTaux) event.row.avtFrais_TauxKm = findTaux.avtTaux_Sup20;
    }

    if (event.action == 'onInput') {
      event.row.avtFrais_Total =
        (event.row.avtFrais_NRM ? parseInt(event.row.avtFrais_NRM) : 0) +
        (event.row.avtFrais_NRS ? parseInt(event.row.avtFrais_NRS) : 0) +
        (event.row.avtFrais_NNH ? parseInt(event.row.avtFrais_NNH) : 0) +
        (event.row.avtFrais_Autre ? parseInt(event.row.avtFrais_Autre) : 0) +
        (event.row.avtFrais_Peage ? parseInt(event.row.avtFrais_Peage) : 0) +
        (event.row.avtFrais_TauxKm ? parseInt(event.row.avtFrais_TauxKm) : 0) *
          (event.row.avtFrais_Km ? parseInt(event.row.avtFrais_Km) : 0);
    }
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.fenetre = params['fenetre'];
      this.init();
    });
  }
}
